import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { NgClass, NgIf } from "@angular/common";

@Component({
    selector: 'app-position-item',
    templateUrl: './positionItem.component.html',
    styleUrls: ['./positionItem.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf]
})

export class PositionItemComponent implements OnInit, OnDestroy {

    constructor(
        private responsive: BreakpointObserver,
        private readonly translate: TranslateService,
    ) { }

    @Input() userRank: boolean = false;
    @Input() rank: number | string;
    subscriptions: Subscription[] = [];
    // RESPONSIVE VARIABLES
    xSmallScreen: boolean;
    // ---

    getAbbreviation(): string {
        switch (this.rank + '') {
            case '1':
                return this.translate.instant('watch.content.ranking.first_position');
            case '2':
                return this.translate.instant('watch.content.ranking.second_position');
            case '3':
                return this.translate.instant('watch.content.ranking.third_position');
            default:
                return '';
        }
    }


    ngOnInit(): void {
        this.subscriptions = [
            this.responsive.observe(Breakpoints.XSmall).subscribe(result => {
                this.xSmallScreen = result.matches ? true : false;
            })
        ]

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe())
    }
}